import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/image/videoplayer.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3ccdb44c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "video-main"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "modal"
  }, null, -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "player",
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_5 = {
  key: 0,
  class: "video-text"
};
var _hoisted_6 = {
  class: "video-text-name"
};
var _hoisted_7 = {
  class: "video-text-time"
};
import { useMatomo } from '@shining3d/matomo';
import { useRouter } from 'vue-router';
import WordHighlighter from 'vue-word-highlighter';
import { $convertUTCDateToLocalDate, $getCdnUrl } from '../../../assets/common/common';
export default {
  props: {
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showInfo: {
      type: Boolean,
      default: true
    },
    query: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var matomo = useMatomo();
    var router = useRouter();
    var imgUrl = computed(function () {
      return $getCdnUrl({
        bucket: props.info.pageBucket,
        dfsID: props.info.pageDfsId
      });
    });
    var toPlay = function toPlay() {
      router.push({
        path: '/video',
        query: {
          bucket: props.info.bucket,
          dfsID: props.info.dfsID,
          comments: props.info.comments,
          docName: props.info.docName,
          createOn: props.info.createOn,
          name: props.info.name
        }
      });
      matomo.log('click', '支持与下载|主题资料|浏览', '用户浏览主题资料');
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        class: "video",
        onClick: toPlay
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
        src: _unref(imgUrl),
        class: "cover",
        alt: ""
      }, null, 8, _hoisted_2), _hoisted_3, _hoisted_4]), props.showInfo ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, [_createVNode(_unref(WordHighlighter), {
        query: __props.query,
        "highlight-style": "color:#FFFFFF;background: #5587FF;"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(props.info.docName), 1)];
        }),
        _: 1
      }, 8, ["query"])]), _createElementVNode("span", _hoisted_7, _toDisplayString(_unref($convertUTCDateToLocalDate)(props.info.createOn, 'YYYY-MM-DD')), 1)])) : _createCommentVNode("", true)]);
    };
  }
};